import { type FieldContentsData } from 'javascripts/shared-types';
import Field from '../../Field';
import { type CardLayoutModelConstructorType } from '../../types';
import { type Task } from 'components/framework/models';

export class StatusLabel extends Field {
  static attributesForModel() {
    return ['status'];
  }

  static availableForModel(modelClass: CardLayoutModelConstructorType) {
    return modelClass.typename === 'Task';
  }

  get title() {
    return 'Status label';
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: 'aha-icon aha-icon-complete' }, text: 'Complete' };
  }

  contentsForRecord(record: Task): FieldContentsData {
    const isComplete = record.status === 'COMPLETE';
    return {
      icon: {
        name: `aha-icon ${
          isComplete ? 'aha-icon-complete' : 'aha-icon-pending'
        }`,
      },
      text: isComplete ? 'Complete' : 'Pending',
    };
  }
}
